import { render } from "./nurse_setting.vue?vue&type=template&id=0d7e61dd&scoped=true"
import script from "./nurse_setting.vue?vue&type=script&lang=js"
export * from "./nurse_setting.vue?vue&type=script&lang=js"

import "./nurse_setting.vue?vue&type=style&index=0&id=0d7e61dd&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7e61dd"]])

export default __exports__